import React from 'react'
import Recruits from './Recruits/Recruits'
import Placed from './Placed/Placed';
import Companies from './Companies/Companies';
import Courses from './Courses/Courses';
import Roadmap from './Roadmap/Roadmap';
import Offcanvas from '../Commons/Offcanvas/Offcanvas';

function Home() {
  return (
    <>
      <Offcanvas />
      <Recruits />
      {/* <Students /> */}
      <Placed />
      <Companies />
      <Courses />
      <Roadmap />
    </>
  )
}

export default Home
